var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "config",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z",
    fill: "inherit",
    opacity: 0.998
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(9.002 9.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4363",
    "data-name": "Group 4363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4362",
    "data-name": "Group 4362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M22.431,9.39H20.478a8.828,8.828,0,0,0-.638-1.543l1.38-1.38a1.567,1.567,0,0,0,0-2.214L19.743,2.776a1.6,1.6,0,0,0-2.214,0l-1.38,1.38a8.852,8.852,0,0,0-1.543-.638V1.565A1.567,1.567,0,0,0,13.041,0H10.955A1.567,1.567,0,0,0,9.39,1.565V3.518a8.869,8.869,0,0,0-1.543.638l-1.38-1.38a1.567,1.567,0,0,0-2.214,0L2.776,4.253a1.568,1.568,0,0,0,0,2.214l1.38,1.38A8.852,8.852,0,0,0,3.517,9.39H1.565A1.567,1.567,0,0,0,0,10.955v2.087a1.567,1.567,0,0,0,1.565,1.564H3.518a8.869,8.869,0,0,0,.638,1.543l-1.38,1.38a1.567,1.567,0,0,0,0,2.214L4.253,21.22a1.568,1.568,0,0,0,2.214,0l1.38-1.38a8.852,8.852,0,0,0,1.543.638v1.952A1.567,1.567,0,0,0,10.955,24h2.087a1.567,1.567,0,0,0,1.565-1.565V20.478a8.852,8.852,0,0,0,1.543-.638l1.38,1.38a1.6,1.6,0,0,0,2.214,0l1.476-1.476a1.567,1.567,0,0,0,0-2.214l-1.38-1.38a8.852,8.852,0,0,0,.638-1.543h1.953A1.567,1.567,0,0,0,24,13.041V10.955A1.567,1.567,0,0,0,22.431,9.39Zm.522,3.652a.522.522,0,0,1-.522.522H20.083a.522.522,0,0,0-.5.391,7.841,7.841,0,0,1-.837,2.02.522.522,0,0,0,.08.634l1.659,1.659a.524.524,0,0,1,0,.739L19,20.482a.537.537,0,0,1-.739,0l-1.659-1.659a.522.522,0,0,0-.634-.08,7.814,7.814,0,0,1-2.019.836.521.521,0,0,0-.391.5v2.347a.522.522,0,0,1-.522.522H10.955a.523.523,0,0,1-.522-.522V20.083a.522.522,0,0,0-.391-.5,7.821,7.821,0,0,1-2.02-.836.516.516,0,0,0-.265-.073.521.521,0,0,0-.369.153L5.729,20.481a.523.523,0,0,1-.739,0L3.514,19.005a.522.522,0,0,1,0-.739l1.659-1.659a.521.521,0,0,0,.08-.634,7.832,7.832,0,0,1-.836-2.02.521.521,0,0,0-.5-.391H1.565a.523.523,0,0,1-.522-.522V10.955a.523.523,0,0,1,.522-.522H3.912a.522.522,0,0,0,.5-.391,7.821,7.821,0,0,1,.836-2.02.521.521,0,0,0-.08-.634L3.514,5.729a.523.523,0,0,1,0-.739L4.991,3.514a.523.523,0,0,1,.739,0L7.388,5.173a.52.52,0,0,0,.634.08,7.832,7.832,0,0,1,2.02-.836.522.522,0,0,0,.391-.5V1.565a.523.523,0,0,1,.522-.522h2.087a.522.522,0,0,1,.522.522V3.912a.522.522,0,0,0,.391.5,7.813,7.813,0,0,1,2.019.836.521.521,0,0,0,.634-.08l1.659-1.659a.536.536,0,0,1,.739,0l1.476,1.476a.524.524,0,0,1,0,.739L18.822,7.388a.522.522,0,0,0-.08.634,7.833,7.833,0,0,1,.837,2.02.521.521,0,0,0,.5.391h2.347a.522.522,0,0,1,.522.522Z",
    fill: "inherit"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4365",
    "data-name": "Group 4365",
    transform: "translate(7.303 7.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4364",
    "data-name": "Group 4364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M116.695,112a4.695,4.695,0,1,0,4.695,4.695A4.7,4.7,0,0,0,116.695,112Zm0,8.346a3.652,3.652,0,1,1,3.652-3.652A3.656,3.656,0,0,1,116.695,120.346Z",
    transform: "translate(-112 -112)",
    fill: "inherit"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.3bde0a5d.svg";
export { ForwardRef as ReactComponent };